import React, { useState, useEffect, useRef } from "react";
import styles from "./choice_shipping.module.css";
import { checkInput } from "../../utils/util_functions";
import { SHIPPING_TYPES } from "../../utils/constants";

const ChoiceShipping = ({
  shippings, orderShipping, setOrderShipping,
  showShippingsList, setShowShippingsList, setFormValid, long=true
}) => {

  const inputRef = useRef(null);
  const inputAdresRef = useRef(null);

  const [statusAdress, setStatusAdress] = useState({});

  useEffect(() => {
    if (orderShipping.name.length > 2 && orderShipping.description.length >= 10) {
      inputRef.current.value = `${orderShipping.name}`;
      inputAdresRef.current.value = `${orderShipping.description}`;
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  }, [orderShipping]);


  const handleClickShippingType = (shipping) => {
    setShowShippingsList(false);
    setOrderShipping({
      ...orderShipping,
      id: shipping.id,
      active: true,
      type: shipping.type,
      name: shipping.name,
      description: shipping.description,
    });
    setStatusAdress({});
    inputRef.current.value = `${shipping.name}`;
    if (shipping.type === SHIPPING_TYPES.selfie) {
      inputAdresRef.current.value = `${shipping.description}`;
      setFormValid(true);
    } else {
      inputAdresRef.current.value = '';
      setFormValid(false);
    }
  }

  const clickInputShipping = () => {
    setShowShippingsList(!showShippingsList);
  }

  const changeAdress = (e) => {
    if (e.target.value.length > 254) {
      e.target.value = e.target.value.slice(0, 254);
    }
    if (orderShipping.type !== SHIPPING_TYPES.selfie) {
      setOrderShipping({
        ...orderShipping,
        description: e.target.value
      });
    }
    const currStatus = checkInput(e.target.value, 10, 254, 'string');
    setStatusAdress({ ...statusAdress, valid: currStatus.valid, text: currStatus.text });
    setFormValid(currStatus.valid);
  }

  return (
    <>
      <div className={styles.container}>
        <div className="shipType">
          <textarea
            type="text"
            id="shipping_name" name="shipping_name"
            required={true}
            className={styles.textarea}
            ref={inputRef}
            onClick={clickInputShipping}
            placeholder="Выберите способ"
          />
          {showShippingsList &&
            <ul className={`${styles.list} ${long ? styles.list__long : styles.list__short}`} id="list_shippings">
              {shippings.map(shipping => {
                return (
                  <li className={styles.item} key={shipping.id}
                    onClick={() => handleClickShippingType(shipping)}
                  >
                    {shipping.name}
                  </li>
                );
              })}
            </ul>
          }
        </div>
      </div>
      <div className="shipDescription">
        <textarea
          className={styles.textarea}
          type="text" name="adress1" id="adress"
          readOnly={orderShipping?.type === SHIPPING_TYPES.selfie ? true : false}
          onChange={changeAdress}
          ref={inputAdresRef}
          placeholder="Введите адрес получателя или пункта выдачи"
          disabled={orderShipping?.type === SHIPPING_TYPES.selfie ? true : false}
          onClick={() => setShowShippingsList(false)}
        />
        <p className={styles.error}>{statusAdress?.text}</p>
      </div>
    </>
  )
};

export default ChoiceShipping;
